import useCardDetailsApi from 'hooks/queries/cards/useCardsDetailsApi';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useCardTranslation = (reference: string) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { card } = useCardDetailsApi(reference || '');

  const [currentLang, setCurrentLang] = useState(language);

  const handleLanguageSwitch = (newLanguage: string) => {
    setCurrentLang(newLanguage);
  };

  const languagesItems = card?.allImagePath
    ? Object.keys(card.allImagePath).map((lang) => (
        <button key={lang} onClick={() => handleLanguageSwitch(lang)} type="button">
          {t(lang)}
        </button>
      ))
    : [];

  return { currentLang, handleLanguageSwitch, languagesItems };
};

export default useCardTranslation;
